import { MessageSquareText } from 'lucide-react'
import { useDriverAttachments } from '../../hooks/useDriverAttachments'

/** A hint to open the accepted trip, independent of the driver's own uploaded documents. */
export default function DriverInstructionsBadge({ shipmentId, comment, canRead }: {
  shipmentId: string
  comment?: string
  canRead: boolean
}) {
  const note = Boolean(comment?.trim())
  const files = useDriverAttachments(canRead && !note ? shipmentId : null)
  if (!canRead || (!note && files.items.length === 0)) return null
  return <span className="is-attention inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-900" title="В заявке есть комментарий или файлы от логиста"><MessageSquareText size={14} />От логиста</span>
}
